export const deleteUser = async (userID, setDeleteUserStatusMessage) => {
  try {
    const response = await fetch(
      "https://wad-backend.ws381566.remote.ac/removeUser.php?adminRequired=true&userID=" + userID,
      {
        method: "DELETE",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        mode: "cors",
      }
    );

    const result = await response.json();

    if (result.status === "authenticationError") {
      window.location.href = "/login";
      return;
    }

    if (result.status === "success") {
      setDeleteUserStatusMessage(result.message);
    } else {
      setDeleteUserStatusMessage(result.message || "Failed to execute query");
    }
  } catch (error) {
    setDeleteUserStatusMessage(error.message);
  }
};